import {throttle} from "./throttle";
import {getEventDelay} from "./get-event-delay";

export function stickyWrappers() {
    let win = window;
    let api = win.api;

    if (api === undefined) {
        win.api = {};
        api = win.api;
    }

    let initialized = false;
    let $win = $(win);
    let positionAbsoluteClass = "position-absolute";
    let positionStickyClass = "position-sticky";
    let stickyWrapperPrefix = ".sticky-";
    let initClassName = "init";
    let stickyWrappers = [];
    let delta = 20;

    function checkIsLargeBreakpoint(stickyWrappersItem) {
        return win.innerWidth >= stickyWrappersItem.largeBreakpoint;
    }

    function _updatePosition(stickyWrappersItem) {
        if (checkIsLargeBreakpoint(stickyWrappersItem)) {
            let $curSection = stickyWrappersItem.$wrapper;
            let curSectionHeight = parseInt($curSection.outerHeight());
            let targetBlock = stickyWrappersItem.holder;
            let targetBlockHeight = parseInt(targetBlock.offsetHeight);

            if((targetBlockHeight + delta) < curSectionHeight){
                let offsetTop = $curSection.offset().top;
                let winScrollTop = $win.scrollTop();
                //let headerHeight = stickyWrappersItem.header.offsetHeight;
                let headerHeight = 0;
                let bottomPosition = offsetTop + curSectionHeight - headerHeight - targetBlockHeight;
                let isScrollOutsideTheBottomPosition = bottomPosition < winScrollTop;
                let isRemoveStickyClass = isScrollOutsideTheBottomPosition || (offsetTop > (winScrollTop + headerHeight));

                if (isRemoveStickyClass) {
                    $curSection.removeClass(positionStickyClass)[(isScrollOutsideTheBottomPosition ? "add" : "remove") + "Class"](positionAbsoluteClass);
                } else {
                    targetBlock.setAttribute("style", `top:${headerHeight}px; width: ${$curSection.width()}px;`);
                    $curSection.removeClass(positionAbsoluteClass).addClass(positionStickyClass);
                }
            }else {
                $curSection
                  .removeClass(positionAbsoluteClass)
                  .removeClass(positionStickyClass);
            }
        }
    }

    function addItems($stickyWrappers) {
        if ($stickyWrappers.length) {
            //let header = document.getElementById("header");

            $stickyWrappers.each(function () {
                let $stickyWrapper = $(this);

                if (!$stickyWrapper.hasClass(initClassName)) {
                    $stickyWrapper.addClass(initClassName);

                    let stickyWrappersItem = {
                        $wrapper: $stickyWrapper,
                        holder: $stickyWrapper.find(stickyWrapperPrefix + "holder")[0],
                        //header: header,
                        largeBreakpoint: parseInt($stickyWrapper.data("large-breakpoint"))
                    };

                    stickyWrappers.push(stickyWrappersItem);

                    $stickyWrapper.data("updatePosition", function () {
                        _updatePosition(stickyWrappersItem);
                    });
                }
            });
        }
    }

    function run() {
        if (stickyWrappers.length) {
            stickyWrappers.forEach(function (item) {
                _updatePosition(item);
            });
        }
    }

    api.stickyWrappers = function ($stickyWrappers) {
        let stickyWrappers = $stickyWrappers || $(stickyWrapperPrefix + "wrapper");

        addItems(stickyWrappers);
        run();

        if (!initialized) {
            initialized = true;

            $win.on("scroll", run);

            ["resize", "orientationchange"].map(function (item) {
                let eventDelay = getEventDelay(item);
                $win.on(item, throttle(run, eventDelay));
            });
        }
    };

    $(document).ready(function () {
        api.stickyWrappers();
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/sticky-wrapper.js